module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_19-1b24388a09f8275e512549958733d013.jpg";